const BATCH_FAILED_STATUS = 'FAILED';
const BATCH_CANCELLED_STATUS = 'CANCELLED';
const BATCH_COMPLETE_STATUS = 'COMPLETE';

class SecureFileUploaderUploadStageController {
  constructor(secureFileUploaderService, batchService, statusIndicatorService, localStorageService) {
    this.name = 'secureFileUploaderUploadStage';
    this.secureFileUploaderService = secureFileUploaderService;
    this.batchService = batchService;
    // this.secureFileUploaderService.updEOPSM-4095
    this.statusIndicatorService = statusIndicatorService;
    this.checkBatchStatus();
    this.localStorageService = localStorageService;
  }

  checkBatchStatus() {
    this.statusIndicatorService.getStatus().then(this.onStatusReceived.bind(this));
  }

  onStatusReceived(response) {
    let status = response.data.content ? response.data.content.workflowStatus : null;
    if (status === BATCH_COMPLETE_STATUS || status === BATCH_FAILED_STATUS || status === BATCH_CANCELLED_STATUS) {
      this.enable();
    } else {
      this.disable();
    }
  }

  submit() {
    if (this.hasAZipFile()) {
      this.fileFormatError = false;
      if (this.hasCorrectCustomerInFileName()) {
        this.IncorrectCustomerInFileName = false;
        this.onUploadBegins();
        this.uploadFile();
      }else{
        this.IncorrectCustomerInFileName = true;
        this.secureFileUploaderService.removeFile();
      }
    } else {
      this.fileFormatError = true;
      this.secureFileUploaderService.removeFile();
    }
  }

  setError(error) {
    this.secureFileUploaderService.setError(error);
  }


  hasAZipFile () {
    let ext = this.uploadState.file && this.uploadState.file.name.split('.').pop();
    return (ext === 'zip' || ext === 'xlsx');
  }

  hasCorrectCustomerInFileName () {
    let hasCorrectFileName = false;
    let zipFileName = this.uploadState.file && this.uploadState.file.name.split('.')[0];
    if (zipFileName && (zipFileName.startsWith('archive-customer_') || zipFileName.startsWith('roster-customer_'))) {
      // supported format is roster-customer_xxx-batch_xxx.zip or archive-customer_xxx-batch_xxx.zip
      let customerIdInFile = zipFileName.split('_')[1].split('-')[0];
      if (customerIdInFile) {
        const isImpersonating = this.localStorageService.get('isImpersonating');
        const customerId = isImpersonating ? this.localStorageService.get('impersonatingCustomer').id : this.localStorageService.get('user').customerId;
        if (customerId == customerIdInFile) {
          hasCorrectFileName = true;
        }
      }
    }else{ // no check for any other filename
      hasCorrectFileName = true;
    }
    return hasCorrectFileName;
  }

  removeError() {
    this.secureFileUploaderService.removeError();
  }

  uploadFile(){
    let batchConfig = null;
    // if (this.isUnmanagedCustomer() && (!this.uploaderXid || !this.uploaderRole || !this.orgXid)) {
    //   this.setError('uploader xid, role, orgXid are ');
    //   return;
    // }
    batchConfig = {
      uploaderXid: this.uploaderXid,
      uploaderRole: this.uploaderRole,
      organizationXid: this.orgXid,
      sectionXid: this.sectionXid
    };
    this.secureFileUploaderService.uploadFile(this.uploadState.file, batchConfig).then(
      this.onUploadSuccess.bind(this),
      this.onUploadFailure.bind(this)
    );
  }

  cancel(){
    this.secureFileUploaderService.cancel();
    this.enable();
  }

  onUploadSuccess () {
  }

  onUploadFailure() {
    let batch = {
      id : this.uploadState.batchId,
      status: BATCH_FAILED_STATUS
    };

    this.s3UploadError = true;
    this.secureFileUploaderService.removeFile();
    this.batchService.updateBatch(batch);
  }

  onUploadBegins() {
    this.removeError();
    this.secureFileUploaderService.resetStages();
    this.disable();
    this.uploadState.uploading = true;
  }

  disable() {
    return this.secureFileUploaderService.isUploadInProgress();
  }

  enable() {
    return !this.secureFileUploaderService.isUploadInProgress();
  }

  hasFileFormatError() {
    return this.fileFormatError;
  }

  hasIncorrectCustomerInFileName() {
    return this.IncorrectCustomerInFileName;
  }

  hasS3UploadError() {
    return this.s3UploadError;
  }

  hasError() {
    return this.secureFileUploaderService.hasError();
  }

  isUnmanagedCustomer() {
    return this.secureFileUploaderService.isUnmanagedCustomer();
  }
}

SecureFileUploaderUploadStageController.$inject = ['secureFileUploaderService','batchService', 'statusIndicatorService', 'localStorageService'];

export default SecureFileUploaderUploadStageController;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderUploadStage/secureFileUploaderUploadStage.controller.js